String.prototype.urlFormat = function (data = []) {
    return stringReplace(this, "{.*?}", data);
}

const stringReplace = (str = '', regExp, replaceData = []) => {
    let a = str.match(new RegExp(`${regExp}`, 'g'));
    if (a && a.length > 0) {
        console.log(a.length)
        replaceData.forEach((item) => {
            str = str.replace(new RegExp(`${regExp}`, ''), item)
        })
    }
    return str;
}

export const getImage = (id, width=1000) => {
    let url = `http://image.tick-tick.cn:4869/${id}?w=${width}`
    return url;
}

Date.prototype.format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1, //月份 
        "d+": this.getDate(), //日 
        "h+": this.getHours(), //小时 
        "m+": this.getMinutes(), //分 
        "s+": this.getSeconds(), //秒 
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
        "S": this.getMilliseconds() //毫秒 
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}